import React from 'react';

import { Box, Center } from '../../../core-ui';

import { SalesNoteWithUser } from '../../../runtypes/SalesNoteRuntype';

import { SalesNote } from './SalesNote';

type Props = {
  salesNotes: Array<
    Omit<SalesNoteWithUser, 'user'> & {
      user: Pick<SalesNoteWithUser['user'], 'id' | 'name'> | null;
    }
  >;
};

export function SalesNoteList(props: Props) {
  const { salesNotes } = props;

  return (
    <Box p={2.5} maxHeight="100%" overflowY="scroll">
      {salesNotes.length > 0 ? (
        salesNotes.map((salesNote, index) => (
          <SalesNote
            key={salesNote.id}
            createdAt={salesNote.createdAt}
            content={salesNote.content}
            username={salesNote.user?.name}
            borderRadius="10px"
            boxShadow="0px 0px 5px 5px rgb(0 0 0 / 20%)"
            marginTop={index !== 0 ? 5 : 0}
            p={5}
          />
        ))
      ) : (
        <Center>{t('No notes to show')}</Center>
      )}
    </Box>
  );
}
